/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesDelete } from "../funcs/riskPoliciesDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteRiskPolicyRequest,
  DeleteRiskPolicySecurity,
} from "../models/operations/deleteriskpolicy.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskPoliciesDeleteMutationVariables = {
  request: DeleteRiskPolicyRequest;
  security?: DeleteRiskPolicySecurity | undefined;
  options?: RequestOptions;
};

export type RiskPoliciesDeleteMutationData = void;

export type RiskPoliciesDeleteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteRiskPolicy risk
 *
 * @remarks
 * Delete a risk analysis policy.
 */
export function useRiskPoliciesDeleteMutation(
  options?: MutationHookOptions<
    RiskPoliciesDeleteMutationData,
    RiskPoliciesDeleteMutationError,
    RiskPoliciesDeleteMutationVariables
  >,
): UseMutationResult<
  RiskPoliciesDeleteMutationData,
  RiskPoliciesDeleteMutationError,
  RiskPoliciesDeleteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskPoliciesDeleteMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskPoliciesDelete(): MutationKey {
  return ["@gram/client", "policies", "delete"];
}

export function buildRiskPoliciesDeleteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskPoliciesDeleteMutationVariables,
  ) => Promise<RiskPoliciesDeleteMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskPoliciesDelete(),
    mutationFn: function riskPoliciesDeleteMutationFn({
      request,
      security,
      options,
    }): Promise<RiskPoliciesDeleteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskPoliciesDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
